/**
 * NotificationBell - Bell icon with unread badge and dropdown
 *
 * Phase 5.1 - In-App Notifications
 */

import { useState, useRef, useCallback } from 'react';
import { Bell } from 'lucide-react';
import { useNotifications } from '../contexts/NotificationContext';
import { NotificationDropdown } from './NotificationDropdown';

export function NotificationBell() {
  const { unreadCount } = useNotifications();
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const handleToggle = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  const hasUnread = unreadCount > 0;

  return (
    <>
      <button
        ref={buttonRef}
        onClick={handleToggle}
        className="p-2 text-slate-400 hover:text-white hover:bg-[#1A1F26] rounded-lg transition-colors relative"
        aria-label={`Notifications${hasUnread ? ` (${unreadCount} unread)` : ''}`}
      >
        <Bell size={20} className={hasUnread ? 'text-teal-400' : undefined} />
        {/* Unread badge - teal to match notifications theme */}
        {hasUnread && (
          <span className="absolute top-1 right-1 min-w-[14px] h-[14px] px-1 bg-teal-500 rounded-full text-[10px] font-semibold text-white flex items-center justify-center">
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        )}
      </button>

      {/* Dropdown (portaled) */}
      {isOpen && (
        <NotificationDropdown
          anchorRef={buttonRef}
          onClose={handleClose}
        />
      )}
    </>
  );
}
